<template>
  <success :title="title" :type="type" :btn-list="btnData"></success>
</template>
<script>
import Success from '../components/Success'
import util from '../../common/util'
import cache from '../../common/cache'

export default {
  components: { Success },
  data() {
    return {
      title: '已提交',
      type: '',
      carId: '',
      btnData: [
        {
          link: '/outbound/manage',
          name: '出库管理'
        }, {
          link: '/outbound/detail',
          name: '出库信息'
        }
      ]
    }
  },
  created() {
    let obrequestId = this.$route.params.id
    let config = this.$route.query.needConfig
    this.btnData[1].link = `/outbound/detail/${obrequestId}`
    if (config === 'error') {
      this.title = '已驳回'
      this.type = 'error'
      util.changeTitle(this.title)
    }
    cache.clearSessionData('OUTBOUND_FROM_DATA')
  }
}

</script>

<style lang="less"></style>
